/** Campos da tela atual de automação do DAM (modo eco legado) que o usuário pode editar. */
export const DAM_LEGACY_AUTOMATION_FIELDS = [
  'REL_DUT_ID_item',
  'EXT_THERM_CFG',
  'MINIMUM_TEMPERATURE',
  'MAXIMUM_TEMPERATURE',
  'ENABLE_ECO_item',
  'ENABLE_ECO_local',
  'ECO_CFG_item',
  'ECO_OFST_START',
  'ECO_OFST_END',
  'ECO_INTERVAL_TIME',
  'ECO_SCHEDULE_START_BEHAVIOR_item',
  'ECO_SETPOINT',
  'ECO_LTC',
  'ECO_LTI',
  'ECO_UPPER_HYSTERESIS',
  'ECO_LOWER_HYSTERESIS',
] as const;

type DamLegacyAutomationField = typeof DAM_LEGACY_AUTOMATION_FIELDS[number];

/** Recorte do `formData` da tela de edição; os itens de select são comparados pelo valor, não pela referência. */
export type DamLegacyAutomationFormData = Partial<Record<DamLegacyAutomationField, unknown>>;

type SnapshotValue = string | number | boolean | null;

export type DamLegacyAutomationSnapshot = Record<string, SnapshotValue>;

const SELECT_VALUE_KEYS = ['valueN', 'value', 'DEV_ID', 'ENVIRONMENT_ID'] as const;

function normalizeSelectItem(item: Record<string, unknown>): SnapshotValue {
  for (const key of SELECT_VALUE_KEYS) {
    const value = item[key];
    if (value != null) return normalizeValue(value);
  }
  return null;
}

function normalizeValue(value: unknown): SnapshotValue {
  if (value == null) return null;
  if (typeof value === 'string') return value.trim();
  if (typeof value === 'number' || typeof value === 'boolean') return value;
  if (typeof value === 'object') return normalizeSelectItem({ ...value });
  return String(value);
}

/** Retrato dos valores editáveis da tela atual, para comparar com o que foi carregado. */
export function toDamLegacyAutomationSnapshot(formData: DamLegacyAutomationFormData, selfReference: boolean): DamLegacyAutomationSnapshot {
  const snapshot: DamLegacyAutomationSnapshot = { SELF_REFERENCE: selfReference };
  for (const field of DAM_LEGACY_AUTOMATION_FIELDS) {
    snapshot[field] = normalizeValue(formData[field]);
  }
  return snapshot;
}

/** Se algum campo da tela atual mudou desde o carregamento; sem retrato carregado, não há alteração. */
export function hasDamLegacyAutomationChanges(loaded: DamLegacyAutomationSnapshot | null, current: DamLegacyAutomationSnapshot): boolean {
  if (!loaded) return false;
  return Object.keys(current).some((key) => loaded[key] !== current[key]);
}
